import { http } from '../../core/services/http';

const loadLocationAlerts = (vendorId: number) =>
  http.get(`vendors/${vendorId}/locationAlertTypes`).then(response => response.data);

export default loadLocationAlerts;
